import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'; // @TODO: This module is only used for the slide-up menu when clicking on the username
import { MaterialModule } from '@app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxEchartsModule } from 'ngx-echarts';
import { WidgetsModule } from '@app/widgets/widget.module';

/**
 * Unfortunately we need to also import the client conponents + keep AOT compilation
 */
import { kapiti_CustomWidgetLayoutComponent } from './custom-widget-layout/custom-widget-layout.component';
import { SharedModule } from '@app/@shared';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    NgbModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
    WidgetsModule,
    SharedModule,
  ],
  declarations: [kapiti_CustomWidgetLayoutComponent],
})
export class ClientKapitiModule {}
